export default "__VITE_ASSET__Bl1HPdi$__"